const ForGenAI = () => {
  return (
    <a href="https://forgen.ai/" target="_blank" rel="noopener noreferrer">
      <div className="md:fixed shadow-lg mt-4 relative rounded-md text-center md:right-10 bottom-2 border border-black w-32 z-50 items-center justify-center bg-white px-4 py-1 pb-2 rounded border">
        <img src="/ForGenAI_Logo.png" className="mt-1" alt="ForGen AI" width="200" />
      </div>
    </a>
  );
};

export default ForGenAI;
